<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <c-card title="Crear categoría">
          <category-form />
        </c-card>
      </div>
    </div>
  </div>
</template>
<script>
import CategoryForm from "@/components/Forms/CategoryForm.vue";
import CCard from "@/components/CCard.vue";
export default {
  components: {
    CategoryForm,
    CCard,
  },
};
</script>
